import script from "./InformacionBasica.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformacionBasica.vue?vue&type=script&setup=true&lang=ts"

import "./InformacionBasica.vue?vue&type=style&index=0&id=a09b8a96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09b8a96"]])

export default __exports__